<template>
    <sui-segment basic>
        <a @click="$router.go(-1)" class="ui left basic button">
            <i class="reply icon"></i>Regresar
        </a>
        <sui-button class="right floated" primary @click="saveUser">Guardar datos</sui-button>
        <sui-button
            class="right floated basic blue"
            secondary
            @click="resetAccess"
            >Resetear acceso</sui-button>

        <!-- <sui-button
            class="right floated basic red"
            @click="toggleBlockUser">
            <span v-if="(user.additionals || {}).isBlocked">Desbloquear usuario</span >
            <span v-else>Bloquear usuario</span >
        </sui-button> -->

        <sui-header dividing>Detalles de usuario</sui-header>

        <sui-tab :menu="{ attached: true, tabular: true }" class="mt-20" @change="tabChange">
            <sui-tab-pane title="Información" icon="user justify" v-if="canEditUserData">
                  <div class="ui icon negative message" v-if="errors.length > 0">
                        <i class="exclamation triangle icon"></i>
                        <div class="content">
                            <div class="header txtl">Verifica los siguientes datos:</div>
                            <ul>
                                <li v-for="error of errors" :key="error">{{error}}</li>
                            </ul>
                        </div>
                    </div>

                <GeneralData :user="user"/>
            </sui-tab-pane>
            <sui-tab-pane title="Menus" icon="sitemap justify" v-if="canEditUserMenu">
                <Menus :user="user" @setMenus="setMenusToSave" />
            </sui-tab-pane>
            <sui-tab-pane title="Permisos" icon="lock justify" v-if="canEditUserPermission">
                <Permissions :user="user" @setPermissions="setPermissionsToSave" />
            </sui-tab-pane>
            <sui-tab-pane title="Cuentas banco" icon="money justify" v-if="canEditUserPermission">
                <UsersBankAccounts :user="user" @setUserBankAccounts="setUserBankAccountsToSave" />
            </sui-tab-pane>
        </sui-tab>

    </sui-segment>

</template>

<script lang="js">
import UserService from '@/services/UserService'
import Utils from '@/common/Utils'
import GeneralData from '@/components/User/GeneralData'
import Menus from '@/components/User/Menus'
import Permissions from '@/components/User/Permissions'
import UsersBankAccounts from '@/components/User/UsersBankAccounts'

export default {
    name: 'userDetails',
    components: { GeneralData, Menus, Permissions, UsersBankAccounts },
    data () {
        return {
            selectedTab: '',
            user: {},
            menus: [],
            menusToSave: [],
            permissionsToSave: [],
            userBankAccountsSelected: [],
            errors: [],
            loader: undefined
        }
    },
    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
        this.loader = this.$loading.show()
        await this.getUserData(this.$route.params.userId)
    },
    methods: {
        tabChange (e, activePane, index) {
            this.selectedTab = activePane.title
        },
        setMenusToSave (menus) {
            this.menusToSave = menus
        },
        setPermissionsToSave (perms) {
            this.permissionsToSave = perms
        },
        setUserBankAccountsToSave (bankAccounts) {
            this.userBankAccountsSelected = bankAccounts
        },
        async getUserData (userId) {
            try {
                const userData = await UserService.getOne(userId)

                delete userData.commissionByWeek

                this.user = userData
                this.menusToSave = this.user.menus
                this.permissionsToSave = this.user.permission
                this.userBankAccountsSelected = this.user.bankAccounts
                this.loader.hide()
            } catch (error) {
                console.error(error)
                const msg = error.response?.data?.message || error.message
                this.$swal({
                    title: 'Error',
                    text: msg,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                }).then(async (result) => {
                    let routeData = this.$router.resolve({ name: 'users' })
                    window.open(routeData.href, '_self')
                })
            }
        },

        async resetAccess () {
            try {
                if (!Utils.userHasPerm('can_update_user_data')) {
                    this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                    return
                }

                this.loader = this.$loading.show()
                let updated = await UserService.resetUserAccess(this.user.id)
                if (updated) {
                    this.$swal({
                        title: 'Se reseteo el acceso al usuario',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#2BBA45',
                        showCloseButton: true
                    })
                }
                this.loader.hide()
            } catch (error) {
                this.loader.hide()
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error'
                })
            }
        },

        async toggleBlockUser () {
            try {
                if (!Utils.userHasPerm('can_block_user_access')) {
                    this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                    return
                }

                this.loader = this.$loading.show()
                let block = !this.user.additionals.isBlocked

                let updated = await UserService.toggleBlockUser(this.user.userId, block)
                if (updated) {
                    this.$swal({
                        title: 'Éxito',
                        text: block ? 'Se bloqueo el acceso al usuario' : 'Se desbloqueo el acceso al usuario',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#2BBA45',
                        showCloseButton: true
                    })
                    this.user.additionals.isBlocked = block
                }
                this.loader.hide()
            } catch (error) {
                this.loader.hide()
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error'
                })
            }
        },

        async saveUser () {
            try {
                if (this.selectedTab === 'Información' && this.canEditUserData) {
                    await this.validateData()
                    if (this.errors.length > 0) {
                        this.loader.hide()
                        return
                    }
                }

                this.loader = this.$loading.show()

                this.user.menus = this.menusToSave
                this.user.permission = this.permissionsToSave
                this.user.bankAccounts = this.userBankAccountsSelected
                this.user.cellphone = parseInt(this.user.cellphone)

                delete this.user.commissionByWeek

                let updated = await UserService.update(this.user.id, this.user)
                if (updated) {
                    this.$swal({
                        title: 'Éxito',
                        text: updated.message || 'Se actualizaron los datos del usuario',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#2BBA45',
                        showCloseButton: true
                    })
                }
                this.loader.hide()
            } catch (error) {
                this.loader.hide()
                const msg = error.response?.data?.message || error.message || 'Hubo un problema, contacta al administrador'
                this.$swal({
                    title: 'Error',
                    text: msg,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
            }
        },
        validateData () {
            this.errors = []

            if (!this.user.firstName || !this.user.fatherSurname || !this.user.motherSurname) this.errors.push('El nombre completo es requerido')
            if (!this.user.birthdate || !this.user.birthCountryCode || !this.user.birthStateCode || !this.user.birthCityCode) this.errors.push('Los datos de nacimiento son requeridos')
            if (!this.user.cellphone) this.errors.push('El celular es requerido')
            if (!this.user.gender) this.errors.push('El sexo es requerido')
            if (!this.user.rfc) this.errors.push('El RFC es requerido')
            if (!this.user.curp) this.errors.push('El CURP es requerido')

            if (!this.user.postalCode || !this.user.address || !this.user.countryCode || !this.user.stateCode || !this.user.cityCode) this.errors.push('Los datos de residencia son requeridos')

            if (!this.user.area) this.errors.push('El área es requerido')
            if (!this.user.position) this.errors.push('El puesto es requerido')
            if (!this.user.leaderId) this.errors.push('Debes seleccionar un lider')
        }

    },

    computed: {
        canEditUserData () {
            return Utils.userHasPerm('can_update_user_data')
        },
        canEditUserMenu () {
            return Utils.userHasPerm('can_update_user_menu')
        },
        canEditUserPermission () {
            return Utils.userHasPerm('can_update_user_permissions')
        }
    }
}
</script>

<style scoped>
    .mb-20 { margin-bottom: 20px!important; }
    .mt-20 { margin-top: 20px!important; }
</style>
